/* eslint-env browser */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { validateSchema } from 'utils/schemaUtil';

import { formSchema, asyncValidate } from './formSchema';
import { PageContainer } from '../../shared/styles';
import Onboarding from '../onboarding';

const useUetgScript = () => {
    useEffect(() => {
        // if production add tracking links only.
        if ('production' !== process.env.NODE_ENV) {
            return;
        }

        let scriptTag;

        (function(w, d, t, r, u) {
            var f, n, i;
            // eslint-disable-next-line no-sequences
            (w[u] = w[u] || []),
                (f = function() {
                    var o = { ti: '199002158', enableAutoSpaTracking: true };
                    // eslint-disable-next-line no-undef,no-sequences
                    (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
                }),
                (n = d.createElement(t)),
                (n.src = r),
                (n.async = 1),
                (n.onload = n.onreadystatechange = function() {
                    var s = this.readyState;
                    (s && s !== 'loaded' && s !== 'complete') || (f(), (n.onload = n.onreadystatechange = null));
                }),
                (i = d.getElementsByTagName(t)[0]),
                i.parentNode.insertBefore(n, i);
            scriptTag = n;
        })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');

        return () => {
            if (scriptTag?.remove && typeof scriptTag.remove === 'function') {
                scriptTag.remove();
            }
        };
    }, []);
};

const Welcome = () => {
    useEffect(() => {
        // if production add tracking links only.
        if ('production' !== process.env.NODE_ENV) {
            return;
        }

        //tracking for linkedInAds
        window.lintrk('track', { conversion_id: 10232929 });

        // Tracking info to Google
        window.gtag('event', 'conversion', {
            send_to: 'AW-994965946/C5HACO3a7pABELrzt9oD',
        });

        // tracking for DPM
        const dpmTrackingScript = document.createElement('script');
        dpmTrackingScript.type = 'text/javascript';
        dpmTrackingScript.async = true;
        dpmTrackingScript.src = 'https://trk.crozdesk.com/aEiruanJyshRamXs-vjN';
        const s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(dpmTrackingScript, s);

        // tracking for Capterra
        const capterraScript = document.createElement('script');
        capterraScript.type = 'text/javascript';
        capterraScript.async = true;
        const capterra_vkey = '21c98982678f451013d116fa654281f3'; //process.env.REACT_APP_CAPTERRA_KEY
        const capterra_vid = '2099922'; //process.env.REACT_APP_CAPTERRA_VID_KEY;
        capterraScript.src =
            'https://ct.capterra.com/capterra_tracker.gif?vid=' + capterra_vid + '&vkey=' + capterra_vkey;
        const sc = document.getElementsByTagName('script')[0];
        sc.parentNode.insertBefore(capterraScript, sc);

        return () => {
            dpmTrackingScript.remove();
            capterraScript.remove();
        };
    }, []);

    useUetgScript();

    return (
        <PageContainer>
            <Onboarding />
        </PageContainer>
    );
};

Welcome.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
    form: 'welcomeForm',
    validate: validateSchema(formSchema),
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    asyncValidate,
    asyncBlurFields: ['subDomain'],
})(Welcome);
